import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
import DataRegions from "@/data/AdminPanel/DataRegions";
import ApiRegion from "@/api/ApiRegion";
let RegionCreate = class RegionCreate extends Vue {
    constructor() {
        super(...arguments);
        this.HasLoading = false;
        this.HasGuessingCords = false;
        this.Breadcrumbs = DataRegions.RegionCreateBreadcrumbs;
        this.newRegion = { is_active: 1, mnp_enabled: 0, delivery: "mail", cdek_point: "MSK108" };
        this.facilitiesList = [];
    }
    async GetAllFacilities() {
        try {
            this.facilitiesList = await ApiRegion.GetEMSFacilities(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            this.facilitiesList = [];
        }
    }
    async GuessCoordinates() {
        this.HasGuessingCords = true;
        try {
            if (!this.newRegion.name) {
                this.HasGuessingCords = false;
                return;
            }
            const response = await ApiRegion.GuessCoordinates(ApiEnter.CurrentSessionUUID, this.newRegion.name);
            this.newRegion.iso_code = response.iso_code;
            this.newRegion.longitude = parseFloat(response.longitude);
            this.newRegion.latitude = parseFloat(response.latitude);
        }
        catch (e) {
            this.HasGuessingCords = false;
            return;
        }
        this.HasGuessingCords = false;
    }
    get CanSubmit() {
        const { facility_id, name, region_name, order, delivery, iso_code, latitude, longitude } = this.newRegion;
        return !!(facility_id && name && region_name && order && delivery && iso_code && latitude && longitude);
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const data = { ...this.newRegion };
            data.order = parseInt(data.order);
            data.mnp_enabled = Number(data.mnp_enabled);
            const region_uuid = await ApiRegion.CreateRegion(ApiEnter.CurrentSessionUUID, data);
            if (region_uuid == undefined || region_uuid.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/secure/regions`);
            });
        }
        this.HasLoading = false;
    }
    created() {
        this.GetAllFacilities();
    }
};
RegionCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RegionCreate);
export default RegionCreate;
